import { render, staticRenderFns } from "./DeviceStatusChips.vue?vue&type=template&id=825ae108&scoped=true&"
import script from "./DeviceStatusChips.vue?vue&type=script&lang=js&"
export * from "./DeviceStatusChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825ae108",
  null
  
)

export default component.exports